// extracted by mini-css-extract-plugin
module.exports = {"ModalCont":"MyModal_ModalCont__gMSBz"};